import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DatePicker from '../../../forecast-app/shared/components/date-picker/date_picker_v3';
import Util from '../../../forecast-app/shared/util/util';
import UpdatePhaseMutation from '../../../mutations/update_phase_mutation';
import DeletePhaseMutation from '../../../mutations/delete_phase_mutation';
import {DATE_PICKER_STYLE} from '../../../constants';
import {FormattedMessage, injectIntl} from 'react-intl';
import {createToast} from '../../../forecast-app/shared/components/toasts/another-toast/toaster';
import ActionsMenu from '../../../forecast-app/shared/components/action-menu/actions_menu';
import {MODAL_TYPE, showModal} from '../../../forecast-app/shared/components/modals/generic_modal_conductor';
import {BUTTON_COLOR, BUTTON_STYLE} from '../../../constants';
import ContextMenu from '../../../forecast-app/shared/components/context-menus/context_menu';
import DuplicatePhaseMutation from '../../../mutations/duplicate_phase_mutation';
import TooltipIcon from '../../../forecast-app/shared/components/tooltips/tooltip_icon';
import Unit4Icon from '../../../images/integrations/unit4-small-logo.svg';
import JiraIcon from '../../../images/integrations/jira-logo.png';
import MergePhaseMutation from '../../../mutations/MergePhaseMutation';
import SendMilestoneToJiraMutationModern from '../../../mutations/send_milestone_to_jira_mutation.modern';

class PhasesPhaseHeader extends Component {
	constructor(props) {
		super(props);

		this.state = {
			inputPhaseTitle: this.props.phase.name || '',
		};
	}

	componentDidMount() {
		if (this.props.focusAddControls) {
			if (this.nameInput) this.nameInput.select();
		}
		if (this.props.isNewMilestone && this.nameInput) {
			this.nameInput.select();
			this.props.scrollToNewMilestone();
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (this.state.inputPhaseTitle !== nextProps.phase.name) {
			this.setState({inputPhaseTitle: nextProps.phase.name});
		}
	}

	focusDateRangePicker(dateRangePicker) {
		if (dateRangePicker) {
			dateRangePicker.handleFocus();
		}
	}

	handlePhaseTitleChange(e) {
		this.setState({
			inputPhaseTitle: e.target.value,
		});
	}

	handleSavePhaseTitle() {
		Util.CommitMutation(UpdatePhaseMutation, {
			id: this.props.phase.id,
			projectId: this.props.project.id,
			name:
				this.state.inputPhaseTitle === ''
					? this.props.intl.formatMessage({id: 'project_scoping.new-scope-group'})
					: this.state.inputPhaseTitle,
		});
	}

	handleKeyPressName(e) {
		if (e.key === 'Enter') {
			this.nameInput.blur();
		}
	}

	handleExpandClick(e) {
		e.stopPropagation();
		e.preventDefault();
		const newTarget = e.relatedTarget || document.activeElement;

		if (
			(newTarget &&
				newTarget.className &&
				(newTarget.className.toLowerCase().includes('calendar') ||
					newTarget.className.toLowerCase().includes('-control'))) ||
			newTarget.tagName === 'INPUT' ||
			newTarget.className.toLowerCase().includes('clear-dates')
		) {
			return;
		}
		this.props.onExpansionChange(this.props.phase.id);
	}
	onContextMenu(e) {
		e.preventDefault();

		const el = e.target;
		const contextMenuPosition = {};

		contextMenuPosition.x = e.pageX;
		//check if there is place for menu underneath cursor
		if (window.innerHeight - e.pageY < 220) {
			contextMenuPosition.y = e.pageY - 150;
		} else {
			contextMenuPosition.y = e.pageY;
		}
		this.setState({
			showContextMenu: true,
			contextMenuElement: el,
			contextMenuPosition,
		});
	}
	closeContextMenu() {
		this.setState({
			showContextMenu: false,
			contextMenuElement: null,
			contextMenuPosition: null,
		});
	}

	//new delete button
	toggleActionMenu(e) {
		this.setState({showActionMenu: !this.state.showActionMenu});
		e.stopPropagation();
	}

	//new delete button
	hideActionMenu() {
		this.setState({showActionMenu: false});
	}

	handleDateRangeChange(startDate, endDate) {
		Util.CommitMutation(UpdatePhaseMutation, {
			id: this.props.phase.id,
			projectId: this.props.project.id,
			startYear: startDate.year(),
			startMonth: startDate.month() + 1,
			startDay: startDate.date(),
			deadlineYear: endDate.year(),
			deadlineMonth: endDate.month() + 1,
			deadlineDay: endDate.date(),
		});
	}

	clearDates() {
		Util.CommitMutation(UpdatePhaseMutation, {
			id: this.props.phase.id,
			projectId: this.props.project.id,
			startYear: null,
			startMonth: null,
			startDay: null,
			deadlineYear: null,
			deadlineMonth: null,
			deadlineDay: null,
		});
	}

	getElemForCol(col) {
		const phase = this.props.phase;
		const empty = this.props.emptyPhase;
		const colName = col.name;
		const {formatMessage, formatNumber} = this.props.intl;
		const isWhite = Util.getTextColor(this.props.project.projectColor) === '#ffffff';
		const integrationLogos = this.getIntegrationLogos();
		switch (colName) {
			// First elem takes space of task name + task ID
			case 'task-name':
				return (
					<div
						className="title"
						data-userpilot={this.props.phaseIndex === 0 ? 'name-input-first' : null}
						title={this.state.inputPhaseTitle}
						style={{maxWidth: this.props.taskCellMaxWidth, minWidth: this.props.taskCellMaxWidth}}
					>
						<div className="editable">
							{empty ? (
								<p className="phase-none">{formatMessage({id: 'project_scopes.tasks-no-scope'})} </p>
							) : (
								<>
									{integrationLogos.length > 0
										? integrationLogos.map(integrationLogo => (
												<div className="phases-header-integration-logo">
													<img
														width={18}
														height={18}
														src={integrationLogo.src}
														alt={integrationLogo.alt}
														title={integrationLogo.title}
													/>
												</div>
										  ))
										: null}
									<input
										data-cy={this.props.cy + '-input'}
										//style={{color: Util.getTextColor(this.props.project.projectColor)}}
										type="text"
										ref={input => {
											this.nameInput = input;
										}}
										value={this.state.inputPhaseTitle}
										onChange={this.handlePhaseTitleChange.bind(this)}
										onBlur={this.handleSavePhaseTitle.bind(this)}
										disabled={this.props.disabled}
										maxLength={191}
										spellCheck={false}
										onKeyPress={this.handleKeyPressName.bind(this)}
									/>
								</>
							)}
						</div>
					</div>
				);
			case 'date':
				let startDate = Util.CreateNonUtcMomentDate(phase.startYear, phase.startMonth, phase.startDay);
				let endDate = Util.CreateNonUtcMomentDate(phase.deadlineYear, phase.deadlineMonth, phase.deadlineDay);
				let isCalculated = false;
				if (this.props.viewer.project.useBaseline) {
					if (!phase.startYear) {
						startDate = Util.CreateNonUtcMomentDate(
							this.props.viewer.project.projectStartYear,
							this.props.viewer.project.projectStartMonth,
							this.props.viewer.project.projectStartDay
						);
						isCalculated = true;
					}
					if (!phase.deadlineYear) {
						endDate = Util.CreateNonUtcMomentDate(
							this.props.viewer.project.projectEndYear,
							this.props.viewer.project.projectEndMonth,
							this.props.viewer.project.projectEndDay
						);
						isCalculated = true;
					}
				}
				return (
					<div data-userpilot={this.props.phaseIndex === 0 ? 'date-picker-first' : ''} className="date-picker">
						{empty ? (
							<div />
						) : (
							<div className="phase-deadline-select">
								<DatePicker
									buttonCy={this.props.cy + '-date-button'}
									disabled={!this.props.lazyDataFetched || this.props.disabled}
									id={phase.id}
									isNewDateRange={true}
									startDate={startDate}
									endDate={endDate}
									handleDateRangeChange={this.handleDateRangeChange.bind(this)}
									clearable={true}
									clearBothDates={this.clearDates.bind(this)}
									//startFrom={phase && phase.name ? phase.name : formatMessage({id: 'common.untitled'})}
									//endFrom={phase && phase.name ? phase.name : formatMessage({id: 'common.untitled'})}
									datePickerStyle={DATE_PICKER_STYLE.SCOPING_MILESTONE_DATE}
									colorInherited={true}
									compactShowYear={true}
									isCalculated={isCalculated}
								/>
							</div>
						)}
					</div>
				);
			case 'done-percentage':
				return !empty ? (
					<div className={'phase-header-data-entry'} data-cy={this.props.cy + '-done'}>
						{this.props.lazyDataFetched ? <span>{phase.progress + ' %'}</span> : <span>-</span>}
					</div>
				) : null;
			case 'low-estimate':
				return (
					<div className={'phase-header-data-entry'} data-cy={this.props.cy + '-low'}>
						{this.props.isEstimatedInHours ? (
							Util.convertMinutesToFullHour(phase.low, this.props.intl)
						) : (
							<FormattedMessage id="common.x_points" values={{points: phase.low}} />
						)}
					</div>
				);
			case 'high-estimate':
				return (
					<div className={'phase-header-data-entry'} data-cy={this.props.cy + '-high'}>
						{this.props.isEstimatedInHours ? (
							Util.convertMinutesToFullHour(phase.high, this.props.intl)
						) : (
							<FormattedMessage id="common.x_points" values={{points: phase.high}} />
						)}
					</div>
				);
			case 'forecast':
				return (
					<div className={'phase-header-data-entry'} data-cy={this.props.cy + '-forecast'}>
						{this.props.isEstimatedInHours ? (
							Util.convertMinutesToFullHour(phase.forecast, this.props.intl)
						) : (
							<FormattedMessage id="common.x_points" values={{points: phase.forecast}} />
						)}
					</div>
				);
			case 'time-entries':
				return (
					<div className={'phase-header-data-entry'} data-cy={this.props.cy + '-time'}>
						{this.props.lazyDataFetched ? Util.convertMinutesToFullHour(phase.timeEntries, this.props.intl) : '-'}
					</div>
				);
			case 'remaining':
				if (this.props.lazyDataFetched) {
					return this.props.isEstimatedInHours ? (
						<div className={'phase-header-data-entry'} data-cy={this.props.cy + '-remaining'}>
							{Util.convertMinutesToFullHour(phase.approvedRemaining, this.props.intl)}
						</div>
					) : (
						<div className={'phase-header-data-entry'} data-cy={this.props.cy + '-remaining'}>
							<FormattedMessage id="common.x_points" values={{points: phase.approvedRemaining}} />
						</div>
					);
				} else {
					return (
						<div className={'phase-header-data-entry'} data-cy={this.props.cy + '-remaining'}>
							-
						</div>
					);
				}
			case 'over-high':
				return (
					<div className={'phase-header-data-entry'} data-cy={this.props.cy + '-over-high'}>
						{this.props.lazyDataFetched ? Util.convertMinutesToFullHour(phase.totalHighDiff, this.props.intl) : '-'}
					</div>
				);
			case 'over-forecast':
				return (
					<div className={'phase-header-data-entry'} data-cy={this.props.cy + '-over-forecast'}>
						{this.props.lazyDataFetched
							? Util.convertMinutesToFullHour(phase.totalForecastDiff, this.props.intl)
							: '-'}
					</div>
				);
			case 'price':
				return this.props.hasFinancialAccess && this.props.hasRateCard && !empty ? (
					<div className={'phase-header-data-entry'} data-cy={this.props.cy + '-price'}>
						<span>
							{this.props.placeUnitBeforeValue
								? this.props.currencySymbol +
								  formatNumber(Math.round(phase.price * 100.0) / 100.0, {format: 'always_two_decimal'})
								: formatNumber(Math.round(phase.price * 100.0) / 100.0, {format: 'always_two_decimal'}) +
								  ' ' +
								  this.props.currencySymbol}
						</span>
					</div>
				) : null;
			case 'actual-price':
				return this.props.hasFinancialAccess && this.props.hasRateCard && !empty ? (
					<div className={'phase-header-data-entry'} data-cy={this.props.cy + '-actual'}>
						{this.props.lazyDataFetched ? (
							<span>
								{this.props.placeUnitBeforeValue
									? this.props.currencySymbol +
									  formatNumber(Math.round(phase.currentPrice * 100.0) / 100.0, {
											format: 'always_two_decimal',
									  })
									: formatNumber(Math.round(phase.currentPrice * 100.0) / 100.0, {
											format: 'always_two_decimal',
									  }) +
									  ' ' +
									  this.props.currencySymbol}
							</span>
						) : (
							'-'
						)}
					</div>
				) : null;
			case 'approved':
				return null;
			case 'empty':
				return !empty ? (
					<div className={'phase-header-controls'} data-cy={this.props.cy + '-actionmenu'}>
						<div className="progress-controls-wrapper">
							<TooltipIcon
								infoText={
									this.props.expanded
										? formatMessage({id: 'workflow.collapse'})
										: formatMessage({id: 'workflow.expand'})
								}
								cy={this.props.cy + '-expand-control'}
								className={'expand-control ' + (this.props.expanded === true ? 'collapse' : 'expand')}
								onClick={this.handleExpandClick.bind(this)}
							/>
						</div>
						<ActionsMenu
							useBlackIcon={!isWhite}
							isWhite={isWhite}
							whiteInner={true}
							options={this.getActionMenuOptions()}
							cy={this.props.cy}
							disabled={this.props.disabled}
						/>
					</div>
				) : (
					<div />
				);
			case 'chip-right':
				return <div />;
			default:
				return null;
		}
	}

	getActionMenuOptions() {
		const {formatMessage} = this.props.intl;
		const {phase} = this.props;

		const invoicedTimeReg = phase.tasks.find(task => task.hasInvoicedTime);
		const lockedTimeReg = phase.tasks.find(task => task.hasLockedTime);

		const actionMenu = [];
		if (!this.props.moveMilestoneDisabled && !phase.unit4Id && !invoicedTimeReg && !lockedTimeReg && !phase.jiraId) {
			actionMenu.push({
				text: formatMessage({id: 'task_location_modal.title'}),
				onClick: this.moveMilestone.bind(this),
				callback: this.moveMilestone.bind(this),
				cy: 'move-btn',
			});
		}

		actionMenu.push({
			text: formatMessage({id: 'common.duplicate'}),
			onClick: this.duplicateMilestone.bind(this),
			callback: this.duplicateMilestone.bind(this),
			cy: 'duplicate-btn',
		});

		actionMenu.push({
			text: formatMessage({id: 'project_scoping.merge_milestone'}),
			onClick: this.mergeMilestone.bind(this),
			callback: this.mergeMilestone.bind(this),
		});

		if (
			(this.props.project?.isJiraProject || this.props.project?.jiraCloudEpicIds) &&
			!phase.jiraId &&
			this.props.company.jiraCloudEnabled
		) {
			actionMenu.push({
				text: formatMessage({id: 'common.move_to_jira'}),
				onClick: this.moveToJira.bind(this),
				callback: this.moveToJira.bind(this),
			});
		}

		if (!phase.unit4Id) {
			actionMenu.push({
				text: formatMessage({id: 'common.delete'}),
				onClick: this.showModalDeleteMilestone.bind(this),
				callback: this.showModalDeleteMilestone.bind(this),
				cy: 'delete-btn',
			});
		}

		return actionMenu;
	}

	moveMilestone() {
		showModal({
			type: MODAL_TYPE.MILESTONE_LOCATION,
			currentProjectId: this.props.project.id,
			milestoneId: this.props.phase.id,
			viewerId: this.props.viewer.id,
		});
	}

	mergeMilestone() {
		const currentPhase = this.props.phase;
		const filterSameIntegration = phase => {
			return (
				phase.node.id !== currentPhase.id &&
				!(currentPhase.jiraId && phase.node.jiraId) &&
				!(currentPhase.unit4Id && phase.node.unit4Id)
			);
		};
		const callbackPositive = selected => {
			const onSuccess = result => {
				createToast({
					duration: 5000,
					message: this.props.intl.formatMessage({id: 'project_scoping.merge_milestone_toast'}),
				});
			};
			Util.CommitMutation(
				MergePhaseMutation,
				{
					id: currentPhase.id,
					mergeFromPhaseId: selected ? selected.value : null,
					projectId: this.props.project.id,
				},
				onSuccess
			);
		};
		const phase_select_options = this.props.viewer.project.phases.edges
			.filter(filterSameIntegration)
			.map(phase => ({value: phase.node.id, label: phase.node.name}));
		showModal({
			type: MODAL_TYPE.SELECT_V2,
			title: this.props.intl.formatMessage({id: 'project_scoping.merge_milestone'}),
			subTitle: this.props.intl.formatMessage(
				{id: 'project_scoping.merge_milestone_description'},
				{milestone: this.props.phase.name}
			),
			defaultCallback: callbackPositive,
			options: phase_select_options,
			emptyText: this.props.intl.formatMessage({id: 'project_scoping.merge_milestone_empty'}),
			label: this.props.intl.formatMessage({id: 'common.scope-group'}),
			multi: false,
			initialValue: null,
		});
	}

	duplicateMilestone() {
		const {formatMessage} = this.props.intl;

		const onSuccess = result => {
			if (this.props.retry) {
				this.props.retry();
			}
			let newPhaseId = null;

			if (result && result.duplicatePhase && result.duplicatePhase.phase && result.duplicatePhase.phase.node) {
				newPhaseId = result.duplicatePhase.phase.node.id;
			}
			createToast({duration: 5000, message: formatMessage({id: 'project_scoping.duplicated_milestone'})});

			this.props.scrollToNewMilestone(newPhaseId);
		};
		Util.CommitMutation(
			DuplicatePhaseMutation,
			{
				id: this.props.phase.id,
				projectId: this.props.project.id,
			},
			onSuccess
		);
	}

	moveToJira() {
		const {formatMessage} = this.props.intl;

		const currentPhase = this.props.phase;
		const callbackPositive = (selectedCustomFieldValues, jiraProjectId) => {
			const onSuccess = result => {
				if (!result.sendMilestoneToJira.phase) {
					createToast({duration: 5000, message: formatMessage({id: 'project_scoping.jira.milestone.notmoved'})});
				} else {
					createToast({duration: 5000, message: formatMessage({id: 'project_scoping.jira.milestone.moved'})});
				}
			};

			const customFields = selectedCustomFieldValues
				? Object.keys(selectedCustomFieldValues).map(key => ({
						key: key,
						value: !Array.isArray(selectedCustomFieldValues[key])
							? selectedCustomFieldValues[key]
							: Array.prototype.map.call(selectedCustomFieldValues[key], s => s.value).toString(),
				  }))
				: undefined;

			Util.CommitMutation(
				SendMilestoneToJiraMutationModern,
				{
					id: currentPhase.id,
					customFields: customFields,
					jiraProjectId: jiraProjectId.value,
				},
				onSuccess
			);
		};
		showModal({
			type: MODAL_TYPE.CREATE_JIRA_MILESTONE,
			defaultCallback: callbackPositive,
			projectId: `${this.props.project.companyProjectId}`,
			milestoneId: currentPhase.id,
		});
	}

	showModalDeleteMilestone() {
		const {formatMessage} = this.props.intl;

		const onSuccess = () => {
			createToast({duration: 5000, message: formatMessage({id: 'scope.has-been-deleted'})});
		};
		const callbackPositive = params => {
			Util.CommitMutation(
				DeletePhaseMutation,
				{
					id: this.props.phase.id,
					projectId: this.props.project.id,
				},
				onSuccess
			);
		};

		showModal({
			type: MODAL_TYPE.WARNING,
			warningMessageId: 'project_scoping.delete_confirmation',
			warningInformation: [
				formatMessage({id: 'project_scoping.delete_confirmation_information'}),
				formatMessage({id: 'common.warning.this_action_can_not_be_undone'}),
			],
			buttons: [
				{
					text: formatMessage({id: 'common.cancel'}),
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.WHITE,
				},
				{
					text: formatMessage({id: 'common.delete'}),
					callback: callbackPositive,
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.RED,
					cy: 'modal-btn-confirm-delete',
				},
			],
		});
	}

	getIntegrationLogos() {
		const integrationLogos = [];
		if (this.props.phase.unit4Id) {
			integrationLogos.push({src: Unit4Icon, alt: 'Unit4', title: 'Unit4'});
		}
		if (this.props.phase.jiraId) {
			integrationLogos.push({src: JiraIcon, alt: 'Jira', title: 'Jira'});
		}
		return integrationLogos;
	}

	render() {
		const empty = this.props.emptyPhase;
		const blackText = Util.getTextColor(this.props.project.projectColor) === '#000000';
		// Had to split the projectColor into red green and blue values due a sass rgba() function limitation
		// rgba() can receive a hex according to the documentation, but misbehaved when I passed a hex to it, therefore we pass r g and b
		const rowElements = [];
		this.props.availableColumns.forEach(col => {
			if ((col.checked && !col.notAnElem) || col.maintainSpace) {
				rowElements.push({
					element: this.getElemForCol(col),
					minWidth: col.minWidth,
					maxWidth: col.maxWidth,
					marginRight: col.marginRight,
					align: col.align,
				});
			}
		});
		return (
			<div
				className={'phases-header-v2' + (empty ? ' no-milestone' : '') + (blackText ? ' black' : ' white')}
				style={!empty ? {backgroundColor: this.props.project.projectColor} : null}
				onClick={!empty ? this.handleExpandClick.bind(this) : null}
				data-userpilot={this.props.phaseIndex === 0 ? 'milestone-header-first' : ''}
			>
				{<div className="overlay"></div>}
				<div className="chip-container">
					<div className="chip-div left" />
					<div className="chip left" />
				</div>
				{rowElements.map((obj, index) => (
					<div
						key={index}
						className={'elem-wrapper' + (!obj.maxWidth ? ' growable' : '')}
						style={{
							height: 40,
							maxWidth: obj.maxWidth ? obj.maxWidth : this.props.taskCellMaxWidth,
							minWidth: obj.minWidth,
							width: obj.width,
							textAlign: obj.align,
						}}
					>
						{obj.element}
					</div>
				))}
				<div className="chip-container">
					<div className="chip-div right" />
					<div className="chip right" />
				</div>

				{this.state.showContextMenu ? (
					<ContextMenu
						options={this.getActionMenuOptions()}
						contextMenuPosition={this.state.contextMenuPosition}
						closeContextMenu={this.closeContextMenu.bind(this)}
					/>
				) : null}
			</div>
		);
	}
}

PhasesPhaseHeader.propTypes = {
	phase: PropTypes.object.isRequired,
	emptyPhase: PropTypes.bool.isRequired,
	locale: PropTypes.string,
	hasRateCard: PropTypes.bool.isRequired,
	disabled: PropTypes.bool,
	currencySymbol: PropTypes.string.isRequired,
	placeUnitBeforeValue: PropTypes.bool.isRequired,
	hasFinancialAccess: PropTypes.bool.isRequired,
	moveMilestoneDisabled: PropTypes.bool.isRequired,
};

export default injectIntl(PhasesPhaseHeader);
